<template>
  <client-only>
    <div v-loading="true" class="custom-loader-container"></div>
  </client-only>
</template>

<script setup lang="ts">

</script>

<style scoped>

</style>